export const MESSAGE_TYPE: { [key: string]: string } = {
  CORRESPONDENCE: 'Correspondence',
  UPDATE: 'Update',
  NOTICE: 'Notice',
  PINNED: 'Pinned',
};

export const MESSAGE_TYPE_NO = {
  ALL: 0,
  READ: 1,
  UNREAD: 2,
  PINNED: 3,
};

export const BUTTON_LABEL: { [key: string]: string } = {
  CORRESPONDENCE: 'Read more',
  UPDATE: 'View transaction',
  NOTICE: 'Download PDF',
};

export const INBOX_ROUTES = {
  INBOX: 'inbox',
};

export const CRM_ROUTES = {
  CRM: 'crm',
  CLARIFICATION: 'clarification',
  FEEDBACK: 'feedback',
  INPUT: 'input',
  SURVEY: 'survey',
  SURVEY_UNSUB: 'unsubscribeSurvey',
};

export const MESSAGE_ACTIONS = {
  PINNED: 'IS-PINNED',
  READ: 'IS-READ',
};

export const AUTH_SCOPES = {
  INBOX_READ: 'COMMON.INBOX:READ',
};

// CRM
export const HELPDESK = 'Helpdesk';
export const HELPDESK_LINK = 'https://www.acra.gov.sg/contact-us';
export const DEFAULT_ERROR_MESSAGE =
  'Sorry, something went wrong. ​We are unable to complete your request. Please contact our Helpdesk for assistance during operating hours.';
export const ERROR_CONSTANT = 'CRM-WF-';

export const ERROR_SEARCH = {
  CODE: 'UDS-VAL-004',
  MESSAGE: 'Please enter keyword to search',
};
